import dayjs from "dayjs";
import DateUtils from "../../../utils/DateUtils";

/**
 * Writes the resolved picker value into the form, if present.
 * @param {{ setValue?: Function }|null|undefined} form
 * @param {string} name
 * @param {import("dayjs").Dayjs|null} value
 */
function applyFormValue(form, name, value) {
  if (form && name) {
    form.setValue(name, value);
  }
}

/**
 * Resolves the initial dayjs value for a date-only picker.
 * ISO/Date defaults are mapped to the Europe/Prague calendar day so display
 * does not shift for users outside that timezone.
 * @param {import("dayjs").Dayjs|string|Date|null|undefined} defaultValue
 * @param {string} name
 * @param {{ setValue?: Function }|null|undefined} form
 * @returns {import("dayjs").Dayjs|null}
 */
export function getInitialValue(defaultValue, name, form) {
  let value = null;
  if (dayjs.isDayjs(defaultValue)) {
    value = defaultValue;
  } else if (defaultValue) {
    value = DateUtils.toPragueDateOnly(defaultValue);
  }

  applyFormValue(form, name, value);
  return value;
}

/**
 * Resolves the initial dayjs value for a date-and-time picker.
 * Preserves the stored instant (hours/minutes). Date-only Prague midnight
 * mapping is for birthdate / DateInput only — do not use it here.
 * @param {import("dayjs").Dayjs|string|Date|null|undefined} defaultValue
 * @param {string} name
 * @param {{ setValue?: Function }|null|undefined} form
 * @returns {import("dayjs").Dayjs|null}
 */
export function getInitialDateTimeValue(defaultValue, name, form) {
  let value = null;
  if (dayjs.isDayjs(defaultValue)) {
    value = defaultValue;
  } else if (defaultValue) {
    const parsed = dayjs(defaultValue);
    value = parsed.isValid() ? parsed : null;
  }

  applyFormValue(form, name, value);
  return value;
}
